<template>
  <div @scroll="scrollmethod">
    <div ref="fixDiv2">
      <div
        :class="scrollCheck ? 'scroll-top' : ''"
        class="carousel-touch-event"
        :style="{
          top: '0px',
          transition: scrollCheck ? 'height 0.3s ease' : '',
        }"
      >
        <div
          :class="scrollCheck ? 'container-fluid my-3' : ''"
          :style="scrollCheck ? 'padding-left:40px; padding-right:40px;' : ''"
        >
          <!-- ------------------------------------------------家戶總覽------------------------------------------------ -->
          <div class="textTitle row">請選擇被保人:</div>
          <div class="d-flex">
            <div
              class="rectangle-green ml-0 pointer"
              @click="sendAll()"
              :style="!isAllFamily ? '' : 'background-color:white;'"
            >
              家戶總覽
            </div>
            <span class="divider"></span>
            <div
              v-if="!isOpen && cacheShow"
              class="d-flex flex-nowrap"
              style="width: calc(100% - 104px)"
              ref="totalWidth"
            >
              <carousel
                :dots="false"
                :nav="false"
                :loop="false"
                :autoWidth="true"
                :lazyLoad="true"
                :mouseDrag="familyResultData.length >= 6"
                :items="3"
                :startPosition="Number(focusIndex)"
                style="width: inherit"
                :key="carouselKey"
                ref="carouselTop"
              >
                <div
                  :style="
                    item.active
                      ? 'background-color: #feeedd;border: solid 1px #f58818;'
                      : ''
                  "
                  class="rectangle-white mb-2 pointer"
                  :key="index"
                  v-for="(item, index) in familyResultData"
                  @click="sendComp(item, index)"
                  :ref="`carousel-totalList-${index}`"
                >
                  <avatar :size="20" :gender="Number(item.sex)" />
                  <span style="width: 130px" class="text-center">{{
                    truncate(item.name, 12)
                  }}</span>
                </div>
              </carousel>
              <span v-if="checkWidth" class="divider-right"></span>
              <span
                style="word-break: keep-all"
                @click="triggerButton()"
                class="ml-2 open-group text-underline pointer"
                v-if="!isOpen && checkWidth"
              >
                展開成員
                <i class="icon-collapse_down icon-line-height"></i>
              </span>
            </div>
            <!-- ------------------------------------------------家戶總覽 - 展開 ------------------------------------------------ -->
            <div
              v-else-if="isOpen && cacheShow"
              style="width: calc(100% - 208px); display: inline-block"
              ref="totalWidthOpen"
            >
              <div
                :style="
                  item.active
                    ? 'background-color: #feeedd;border: solid 1px #f58818;'
                    : ''
                "
                class="rectangle-white mb-2 pointer"
                :key="index"
                v-for="(item, index) in familyResultData"
                @click="sendComp(item, index)"
                :ref="`carousel-totalList-${index}`"
              >
                <avatar :size="20" :gender="Number(item.sex)" />
                <span style="width: 130px" class="text-center">{{
                  truncate(item.name, 12)
                }}</span>
              </div>
            </div>
            <span
              style="word-break: keep-all"
              v-if="isOpen && checkWidth"
              @click="triggerButton()"
              class="ml-2 open-group-top text-underline pointer"
            >
              收合成員
              <i class="icon-collapse_up icon-line-height"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div v-show="scrollCheck" :style="{ height: `${addHeight}px` }"></div>
    <div class="row">
      <div class="col-12 text-right mt-4" v-if="canEdit">
        <div>
          <button class="btn btn-sm btn-primary" @click="routeToEdit()">
            編輯保單
          </button>
        </div>
      </div>
    </div>
    <div class="mt-4">
      <section v-if="!isLoading">
        <!-- ---------國泰人壽壽險--------- -->
        <!-- ---------國泰人壽保單--------- -->
        <div v-if="showLifeInsurance">
          <cathay-life-insurance
            :datas="
              memberObj
                ? getCathayInsuranceResult.filter((el) =>
                    clickMember.includes(el.insuredpersonid)
                  )
                : getCathayInsuranceResult
            "
            :selectInventInsurance="selectInventInsurance"
            :modalLoading="modalLoading"
            ref="cathay-life-insurance"
          >
          </cathay-life-insurance>
          <!-- ---------國泰人壽保單--------- -->
          <!-- ---------其他人壽保單--------- -->
          <other-life-insurance
            :datas="
              memberObj
                ? getOtherInsuranceResult.otherinfo.filter((el) =>
                    clickMember.includes(el.insuredpersonid)
                  )
                : getOtherInsuranceResult.otherinfo
            "
            ref="other-life-insurance"
          >
          </other-life-insurance>
          <!-- ---------其他人壽保單--------- -->
          <!-- ---------商品建議書--------- -->
          <product-suggest
            :datas="
              memberObj
                ? getOtherInsuranceResult.suggestinfo.filter((el) =>
                    clickMember.includes(el.insuredpersonid)
                  )
                : getOtherInsuranceResult.suggestinfo
            "
            ref="product-suggest"
          >
          </product-suggest>
          <!-- ---------商品建議書--------- -->
          <message
            v-if="
              !isLifeInsuranceHasData &&
              !isAll &&
              !this.isAllLoading &&
              !memberObj
            "
            message="此家戶尚未有任何壽險保單"
          />
        </div>

        <!-- ---------國泰人壽產險--------- -->
        <!-- <div v-if="showPropertyInsurance"> -->
          <!-- ---------國泰產險-健康險--------- -->
          <!-- <cathay-property-health-insurance
            :datas="
              memberObj
                ? assignFamilyInfo(
                    [].concat(
                      filterBeforePolicies(
                        getCustInsurance_CCIPLN4MVResult.policies
                      ),
                      assignKeyinBySelf(
                        filterBeforePolicies(
                          getCustInsurance_CCIPLN4MVResult.policiesselfinput
                        )
                      )
                    )
                  ).filter((el) => clickMember.includes(el.CEISDNO))
                : assignFamilyInfo(
                    [].concat(
                      filterBeforePolicies(
                        getCustInsurance_CCIPLN4MVResult.policies
                      ),
                      assignKeyinBySelf(
                        filterBeforePolicies(
                          getCustInsurance_CCIPLN4MVResult.policiesselfinput
                        )
                      )
                    )
                  )
            "
            ref="cathay-property-health-insurance"
          >
          </cathay-property-health-insurance> -->
          <!-- ---------國泰產險-健康險--------- -->
          <!-- ---------國泰產險-傷害險--------- -->
          <!-- <cathay-property-hurt-insurance
            :datas="
              memberObj
                ? assignFamilyInfo(
                    [].concat(
                      filterBeforePolicies(
                        getCustInsurance_CCIPLN2MVResult.policies
                      ),
                      assignKeyinBySelf(
                        filterBeforePolicies(
                          getCustInsurance_CCIPLN2MVResult.policiesselfinput
                        )
                      )
                    )
                  ).filter((el) => clickMember.includes(el.CEISDNO))
                : assignFamilyInfo(
                    [].concat(
                      filterBeforePolicies(
                        getCustInsurance_CCIPLN2MVResult.policies
                      ),
                      assignKeyinBySelf(
                        filterBeforePolicies(
                          getCustInsurance_CCIPLN2MVResult.policiesselfinput
                        )
                      )
                    )
                  )
            "
            ref="cathay-property-hurt-insurance"
          >
          </cathay-property-hurt-insurance> -->

          <!-- ---------國泰產險-傷害險--------- -->
          <!-- ---------國泰產險-新種險--------- -->
          <!-- <cathay-property-new-insurance
            :datas="
              memberObj
                ? assignFamilyInfo(
                    [].concat(
                      filterBeforePolicies(
                        getCustInsurance_CCIPLN1MVResult.policies
                      ),
                      assignKeyinBySelf(
                        filterBeforePolicies(
                          getCustInsurance_CCIPLN1MVResult.policiesselfinput
                        )
                      )
                    )
                  ).filter((el) => clickMember.includes(el.CEISDNO))
                : assignFamilyInfo(
                    [].concat(
                      filterBeforePolicies(
                        getCustInsurance_CCIPLN1MVResult.policies
                      ),
                      assignKeyinBySelf(
                        filterBeforePolicies(
                          getCustInsurance_CCIPLN1MVResult.policiesselfinput
                        )
                      )
                    )
                  )
            "
            ref="cathay-property-new-insurance"
          >
          </cathay-property-new-insurance> -->
          <!-- ---------國泰產險-新種險--------- -->
          <!-- ---------其他產險-新種險--------- -->
          <!-- <other-property-new-insurance
            :datas="
              memberObj
                ? assignFamilyInfo(
                    [].concat(
                      filterBeforePolicies(
                        getOtherPropertyInsuranceResult.othernewdataset
                      )
                    )
                  ).filter((el) => clickMember.includes(el.ceisdno))
                : assignFamilyInfo(
                    [].concat(
                      filterBeforePolicies(
                        getOtherPropertyInsuranceResult.othernewdataset
                      )
                    )
                  )
            "
            ref="other-property-new-insurance"
          >
          </other-property-new-insurance> -->
          <!-- ---------其他產險-新種險--------- -->
          <!-- ---------國泰產險-車險--------- -->
          <!-- <cathay-property-car-insurance
            :datas="
              memberObj
                ? assignFamilyInfo(
                    [].concat(
                      filterBeforePolicies(
                        getCustInsurance_CCIPLC1MVResult.policies
                      ),
                      assignKeyinBySelf(
                        filterBeforePolicies(
                          getCustInsurance_CCIPLC1MVResult.policiesselfinput
                        )
                      )
                    )
                  ).filter((el) => clickMember.includes(el.ceisdno))
                : assignFamilyInfo(
                    [].concat(
                      filterBeforePolicies(
                        getCustInsurance_CCIPLC1MVResult.policies
                      ),
                      assignKeyinBySelf(
                        filterBeforePolicies(
                          getCustInsurance_CCIPLC1MVResult.policiesselfinput
                        )
                      )
                    )
                  )
            "
            ref="cathay-property-car-insurance"
          >
          </cathay-property-car-insurance> -->
          <!-- ---------國泰產險-車險--------- -->
          <!-- ---------國泰產險-火險--------- -->
          <!-- <cathay-property-fire-insurance
            :datas="
              memberObj
                ? assignFamilyInfo(
                    [].concat(
                      filterBeforePolicies(
                        getCustInsurance_CCIPLF1MVResult.policies
                      ),
                      assignKeyinBySelf(
                        filterBeforePolicies(
                          getCustInsurance_CCIPLF1MVResult.policiesselfinput
                        )
                      )
                    )
                  ).filter((el) => clickMember.includes(el.ceisdno))
                : assignFamilyInfo(
                    [].concat(
                      filterBeforePolicies(
                        getCustInsurance_CCIPLF1MVResult.policies
                      ),
                      assignKeyinBySelf(
                        filterBeforePolicies(
                          getCustInsurance_CCIPLF1MVResult.policiesselfinput
                        )
                      )
                    )
                  )
            "
            ref="cathay-property-fire-insurance"
          >
          </cathay-property-fire-insurance> -->
          <!-- ---------國泰產險-火險--------- -->
          <!-- ---------其他產險-車險--------- -->
          <!-- <other-property-car-insurance
            :datas="
              memberObj
                ? assignFamilyInfo(
                    [].concat(
                      filterBeforePolicies(
                        getOtherPropertyInsuranceResult.othermotordataset
                      )
                    )
                  ).filter((el) => clickMember.includes(el.ceisdno))
                : assignFamilyInfo(
                    [].concat(
                      filterBeforePolicies(
                        getOtherPropertyInsuranceResult.othermotordataset
                      )
                    )
                  )
            "
            ref="other-property-car-insurance"
          >
          </other-property-car-insurance> -->

          <!-- ---------其他產險-車險--------- -->
          <!-- ---------其他產險-火險--------- -->
          <!-- <other-property-fire-insurance
            :datas="
              memberObj
                ? assignFamilyInfo(
                    [].concat(
                      filterBeforePolicies(
                        getOtherPropertyInsuranceResult.otherfiredataset
                      )
                    )
                  ).filter((el) => clickMember.includes(el.ceisdno))
                : assignFamilyInfo(
                    [].concat(
                      filterBeforePolicies(
                        getOtherPropertyInsuranceResult.otherfiredataset
                      )
                    )
                  )
            "
            ref="other-property-fire-insurance"
          >
          </other-property-fire-insurance> -->

          <!-- ---------其他產險-火險--------- -->
          <!-- <message
            v-if="!isPropertyInsuranceHasData && !isAll && !memberObj"
            message="此家戶尚未有任何產險保單"
          />
        </div> -->
        <!-- ---------國泰人壽產險--------- -->
        <message
          v-if="isAll && !hasData && !memberObj"
          message="此家戶尚未有任何保單"
        />
        <message v-if="memberObj && noShowData" message="無可查詢資訊" />
      </section>

      <message
        class="mt-5 d-flex justify-content-center"
        v-else
        loading
        message="資料讀取中，請稍候..."
      />

      <leave-page-warning-modal
        :open="leavePageWarningModalOpen"
        message="即將離開保單健檢結果，編輯保單後須重新執行保單健檢"
        @submit="submitToLeave()"
        @close="panelClose('leavePageWarningModalOpen')"
      />

      <insurance-modal
        :open="insuranceModalOpen"
        :no="selectedNo"
        :insuranceName="insuranceName"
        :prodId="insuranceProdId"
        :isShowNoIdRelationship="isShowNoIdRelations"
        @close="panelClose('insuranceModalOpen')"
      />

      <invent-insurance-modal
        :open="inventInsuranceModalOpen"
        :no="selectedNo"
        :insuranceName="insuranceName"
        :prodId="insuranceProdId"
        :targetId="insuranceTargetId"
        @close="panelClose('inventInsuranceModalOpen')"
      />
    </div>
  </div>
</template>

<script>
import Avatar from "@/desktop/views/mv/components/Avatar";
import carousel from "vue-owl-carousel2";
import LeavePageWarningModal from "@/desktop/views/mv/components/leavePageWarningModal";
import InsuranceModal from "../components/bkInsuranceModal";
import InventInsuranceModal from "../components/bkInventInsuranceModal";
import { isInvProd } from "@/service";
import PolicyListMixins from "./bkPolicyList";
import HardwordMixins from "@/mixins/Hardword"; // for 難字更新
import { mapActions, mapGetters } from "vuex";
export default {
  components: {
    Avatar,
    carousel,
    LeavePageWarningModal,
    InventInsuranceModal,
    InsuranceModal,
  },
  mixins: [PolicyListMixins, HardwordMixins],
  data: () => ({
    //收合
    isOpen: false,
    //置頂
    scrollCheck: false,
    //頁首字樣
    title: "",
    //FOCUSBUTTON
    focusIndex: 0,
    searchHolderIndex: localStorage.searchHolderIndex,
    addHeight: 35,
    checkWidth: false,
    //cache
    cacheShow: true,
    noShowData: true,
    carouselKey: 0,
    headChange: false,
    leavePageWarningModalOpen: false,
    selectedNo: "",
    insuranceName: "",
    insuranceProdId: "",
    insuranceTargetId: "",
    isShowNoIdRelations: false,
    proccessDatasList: [],
    inventInsuranceModalOpen: false,
    insuranceModalOpen: false,
    modalLoading: false,
    selectInventInsurance: {},
  }),
  computed: {
    ...mapGetters([
      "FamilyResultFilter",
      "BaseUrl",
      "CheckApc",
      "UserInfo",
      "AllFamilyResult",
    ]),
    familyResultData() {
      return this.$router.history.current.name === "bkPolicyList"
        ? this.AllFamilyResult
        : this.FamilyResultFilter;
    },
    canEdit() {
      return !!this.$route.meta.editable;
    },
    isAll() {
      return this.policyType === "A";
    },
    isAllFamily() {
      return this.familyResultData.some((el) => el.active);
    },
    memberObj() {
      return this.familyResultData.find((el) => el.active);
    },
    clickMember() {
      return this.memberObj.csidno || this.memberObj.serNo;
    },
    clickMemberInfo() {
      return { name: this.memberObj.name, sex: this.memberObj.sex };
    },
    showLifeInsurance() {
      return ["A", "L"].includes(this.policyType);
    },
    showGroupInsurance() {
      return ["A", "G"].includes(this.policyType);
    },
    // showPropertyInsurance() {
    //   return ["A", "P"].includes(this.policyType);
    // },
    policyType: {
      get() {
        return "A";
      },
      set(val) {
        this.$router.push({ query: { policyType: val } });
        this.showDataCheck();
      },
    },
    isBox() {
      //判斷是否為box   this.UserInfo.userType === 'box'
      return this.UserInfo.userType === "box";
    },
  },
  watch: {
    $route: function (to, from) {
      if (
        (to.name === "bkPolicyList" && from.name !== "bkPolicyList") ||
        (to.name === "bkPolicyInfoPDF" && from.name !== "bkPolicyInfoPDF")
      ) {
        this.init();
        this.sendAll();
      }
    },
  },
  mounted() {
    //初始化過後更新刷新參數

    this.$route.meta.reload = false;
    this.init();
  },
  created() {
    window.addEventListener("resize", this.resizeWindow);
    //  滾動監聽
    document.addEventListener("scroll", this.scrollmethod);
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeWindow);
    //  滾動監聽
    document.removeEventListener("scroll", this.scrollmethod);
  },
  methods: {
    ...mapActions(["setPageLock", "updateFamilyResultFilter"]),
    sendAll() {
      this.familyResultData.map((el) => {
        this.$set(el, "active", false);
        return el;
      });
    },
    init() {
      this.cacheShow = true;
      this.selectInventInsurance = (insure) => {
        if (!insure.b015plcno) {
          this.modalLoading = true;
          isInvProd(this.$store.state.userInfo.id, insure.prodid).then(
            (result) => {
              if (result.header.status === "0") {
                if (result.body.isINV_PROD) {
                  this.selectedNo = insure.policynumber;
                  this.insuranceName = insure.productname;
                  this.insuranceProdId = insure.prodid;
                  this.insuranceTargetId = insure.targetId;
                  this.panelOpen("inventInsuranceModalOpen");
                } else {
                  this.selectedNo = insure.policynumber;
                  this.insuranceName = insure.productname;
                  this.insuranceProdId = insure.prodid;
                  this.isShowNoIdRelations = this.noIdRelationsShowOrNot(
                    insure.policynumber,
                    insure.targetId
                  ); //是否要顯示無記名關係選項
                  this.panelOpen("insuranceModalOpen");
                }
              }
              this.modalLoading = false;
            }
          );
        }
      };
      this.carouselInit();
      this.resizeWindow();
    },
    carouselInit() {
      this.carouselKey = this.carouselKey + 1;
      this.$nextTick(() => {
        $(".carousel-touch-event").on("touchmove", (e) => {
          e.preventDefault();
        });
      });
    },

    scrollmethod() {
      //當滑動到家戶總覽之後自動置頂
      let scrollTop =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        document.body.scrollTop;
      let showPx = 200;
      if (scrollTop > showPx) {
        this.$refs.carouselTop.refresh();
        this.scrollCheck = true;
      } else {
        this.scrollCheck = false;
      }
    },
    sendComp(item, index) {
      this.focusIndex = index;
      this.sendAll();
      item.active = true;
      this.isOpen = false;
      this.showDataCheck();
    },
    triggerButton() {
      this.isOpen = !this.isOpen;
      this.resizeWindow();
    },
    resizeWindow() {
      this.$nextTick(() => {
        let ref = "carousel-totalList-0";
        let totalWidth =
          this.$refs.totalWidth !== undefined
            ? this.$refs.totalWidth.clientWidth
            : this.$refs.totalWidthOpen.clientWidth + 104;
        this.checkWidth =
          (this.$refs[ref][0].clientWidth + 10) *
            this.familyResultData.length >=
          totalWidth - 104;
        if (this.$refs.totalWidth === undefined && this.checkWidth == false) {
          this.isOpen = false;
        }
      });
    },
    filterBeforePolicies(policies) {
      //當天之前失效保單不顯示
      const toDay = new Date();
      return policies
        ? policies.filter(
            (item) => new Date(item.CELPSDT || item.celpsdt) > toDay
          )
        : [];
    },
    showDataCheck() {
      this.$nextTick(() => {
        let showFlag = true;
        let componentsRefArray = [
          "cathay-life-insurance",
          "other-life-insurance",
          "product-suggest",
          "cathay-group-insurance",
          // "cathay-property-health-insurance",
          // "cathay-property-hurt-insurance",
          // "cathay-property-new-insurance",
          // "other-property-new-insurance",
          // "cathay-property-car-insurance",
          // "cathay-property-fire-insurance",
          // "other-property-car-insurance",
          // "other-property-fire-insurance",
        ];
        componentsRefArray.map((e) => {
          if (this.$refs[e])
            if (this.$refs[e].datas.length !== 0) showFlag = false;
        });
        this.noShowData = showFlag;
      });
    },
    noIdRelationsShowOrNot(policynumber, targetId) {
      let result = false;
      let prodidList = this.getCathayInsuranceResult.filter((item) => {
        return item.insuredpersonid == targetId;
      });
      prodidList = prodidList[0].majorpolicyinfolist.filter((item) => {
        return item.policynumber == policynumber;
      });
      prodidList = prodidList[0].policyinfolist.map(function (e) {
        return e.prodid;
      });

      if (prodidList.length) {
        //新增主約險種: HF、 LQ、 MU、 OG
        let checkProdIds = [
          "A3",
          "AD",
          "AD2",
          "AE",
          "AG",
          "4V",
          "6V",
          "7V",
          "A9",
          "A91",
          "AO",
          "AO1",
          "AV",
          "C3",
          "C9",
          "D3",
          "D6",
          "AI",
          "AL",
          "AQ",
          "AQ1",
          "B4",
          "B7",
          "1G",
          "2G",
          "3G",
          "AS",
          "HF3",
          "HFC",
          "LQ3",
          "MU3",
          "OD3",
          "PG3",
          "AN",
          "AN1",
          "A3",
          "AD",
          "AD2",
          "AE",
          "AG",
          "4V",
          "6V",
          "7V",
          "A8",
          "A81",
          "A9",
          "A91",
          "AO",
          "AO1",
          "AV",
          "C2",
          "C3",
          "C8",
          "C9",
          "D2",
          "D3",
          "D5",
          "D6",
          "AJ",
          "1G",
          "2G",
          "3G",
          "AT",
          "HF2",
          "HFB",
          "HF3",
          "HFC",
          "LQ2",
          "LQ3",
          "MU2",
          "MU3",
          "OD2",
          "OD3",
          "PG2",
          "PG3",
          "HF",
          "LQ",
          "MU",
          "OG",
        ];
        let checkProdsSet = new Set(checkProdIds);
        let prodIdList = prodidList.map((item) => {
          return item.replace("_", "");
        });
        result = prodIdList.map((id) => checkProdsSet.has(id)).includes(true);
      }
      return result;
    },
    routeToEdit() {
      if (this.$route.name == "bkPolicyInfoPDF") {
        this.panelOpen("leavePageWarningModalOpen");
      } else {
        this.$router.push({ name: "bkPolicyInfo-edit-list" });
      }
    },
    submitToLeave() {
      this.panelClose("leavePageWarningModalOpen");
      this.$router.push({ name: "bkPolicyInfo-edit-list" });
    },
  },
};
</script>
<style scoped>
.rectangle-green {
  display: inline-flex;
  align-items: center;
  width: 90px;
  height: 40px;
  padding: 9px 10px;
  color: #048f3a;
  font-size: 16px;
  border-radius: 25px;
  border: solid 1px #048f3a;
  background-color: #ebf7f0;
}

.divider {
  padding: 30px 0px 9px 0px !important;
  margin-left: 12px;
  border-left: 2px solid #e0e1e3;
  background-color: #e0e1e3;
  font-size: 0;
  height: 40px;
}

.divider-right {
  padding: 30px 0px 9px 0px !important;
  margin-left: 4px;
  border-left: 2px solid #e0e1e3;
  background-color: #e0e1e3;
  font-size: 0;
  height: 40px;
}

.rectangle-white {
  display: inline-flex;
  align-items: center;
  color: #323a45;
  font-size: 16px;
  margin-left: 10px;
  padding: 9px 10px;
  border-radius: 25px;
  border: solid 1px #c2c4c7;
  background-color: #ffffff;
}
.open-group {
  line-height: 40px;
  font-family: PingFangTC;
  font-size: 16px;
  color: #048f3a;
}
.icon-line-height {
  line-height: 40px;
}
.open-group-top {
  vertical-align: top;
  font-family: PingFangTC;
  font-size: 16px;
  color: #048f3a;
}

.scroll-top {
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.15);
  background-color: rgb(255 255 255);
  position: fixed;
  right: 0;
  width: 100%;
  z-index: 10;
}
.textTitle {
  font-family: PingFangTC;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #323a45;
  padding-bottom: 12px;
}
.pointer {
  cursor: pointer;
}
</style>